import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Heading } from '@printdeal/ui-library';
import { SupportArticleCard } from './SupportArticleCard';
import { LinkedSupportArticle } from '../../types/helpCenter/helpCenter';

interface IHelpCenterLinkedSupportrticles {
  linkedSupportArticles: LinkedSupportArticle[];
}
const HelpCenterLinkedSupportArticles = ({ linkedSupportArticles }: IHelpCenterLinkedSupportrticles) => (
  <section>
    <Heading as="h2" variant="display" size="2" className="pd-mb-4">
      <FormattedMessage
        id="helpcenter.article.related.article"
        defaultMessage="Related articles"
      />
    </Heading>
    <Grid className="pd-grid-cols-1 pd-gap-6 sm:pd-grid-cols-2">
      {linkedSupportArticles?.map((linkedEntry) => (
        <Grid.Item key={linkedEntry.path}>
          <SupportArticleCard
            linkedArticle={linkedEntry}
            pageName="support_article_page"
          />
        </Grid.Item>
      ))}
    </Grid>
  </section>
);

export default HelpCenterLinkedSupportArticles;
